import { ApiBaseUrl, VendeurApikey } from "./http";

export type ContactFormPayload = {
  nom_complet?: string;
  email?: string;
  tel?: string;
  message: string;
  subject?: string;
  formule?: string;
  source?: string;
  contact_type?: string;
};

/**
 * Envoie un message de contact via l'API backend.
 * Le destinataire e-mail est résolu côté serveur via l'en-tête api-key (VendeurApikey).
 * @see CONFIG_CONTACT_FORM_EMAIL.md
 */
export async function submitContactForm(
  data: ContactFormPayload,
): Promise<void> {
  const payload = {
    nom_complet: data.nom_complet || "",
    email: data.email || "",
    tel: data.tel || "",
    message: data.message,
    subject: data.subject || "Message de contact",
    formule: data.formule || "",
    source: data.source || "",
    contact_type: data.contact_type || "",
  };

  const res = await fetch(`${ApiBaseUrl}/api/visiteur/contacts/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "api-key": VendeurApikey,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`Erreur serveur : ${res.status}`);
  }
}
